export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7259.8c1914cd.jpg";